import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import CustomLink from '@/bit/components/components.custom-link';
import Button, {
  BUTTON_TYPE,
  BUTTON_WIDTH,
} from '@/bit/components/components.button';
import IconGlyph from '@/bit/components/components.icon-glyph';

function DefaultErrorPage({
  title,
  description,
  showButtons,
  buttonHref,
  buttonOnClick,
  buttonText,
  iconId,
  iconColor,
  iconKind,
  showIcon,
  linkText,
  linkUrl,
  showLink,
}) {
  return (
    <>
      {showIcon && (
        <IconGlyph
          id={iconId}
          color={iconColor}
          layoutSize={{ height: 64, width: 64 }}
          kind={iconKind}
        />
      )}
      <Text
        className="stopper__title"
        text={title}
        color={TEXT_COLOR.GREY6}
        kind={TEXT_KIND.HEADING}
        fontType={TEXT_FONT_WEIGHT.BOLD}
        size={TEXT_SIZE.TITLE4}
      />
      <Text
        className="stopper__subtitle"
        text={description}
        kind={TEXT_KIND.PARAGRAPH}
        color={TEXT_COLOR.GREY5}
        size={TEXT_SIZE.TITLE6}
      />
      {showButtons && (
        <div className="stopper__buttons">
          <Button
            href={buttonOnClick ? null : buttonHref}
            label={buttonText}
            onClick={buttonOnClick}
            className="stopper__button"
            type={BUTTON_TYPE.PRIMARY}
            width={BUTTON_WIDTH.MEDIUM}
            taggingInfo={{
              componentName: 'button',
              componentVariation: 'all',
              componentContent: buttonText,
              componentPerso: '',
              componentProduct: '',
            }}
          />
          {showLink && linkText && (
            <CustomLink
              className="stopper__link"
              role="button"
              onClick={() => {
                window.location.href = linkUrl;
              }}
              taggingInfo={{
                componentName: 'link',
                componentVariation: 'all',
                componentContent: linkText,
                componentPerso: '',
                componentProduct: '',
              }}
            >
              <Text
                text={linkText}
                kind={TEXT_KIND.SPAN}
                color={TEXT_COLOR.BLUEA}
                display={TEXT_DISPLAY.INLINE}
                size={TEXT_SIZE.CAPTION1}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </CustomLink>
          )}
        </div>
      )}
      <style jsx>
        {`
          :global(.stopper__title) {
            margin-top: 20px;
            margin-bottom: 16px;
          }
          :global(.stopper__icon) {
            height: 64px;
          }
          .stopper__buttons {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 16px;
            width: 100%;
            :global(.stopper__button) {
              width: 100%;
            }
            :global(.stopper__link) {
              margin-top: 16px;
            }
          }
          @media screen and (min-width: 768px) {
            .stopper__buttons {
              display: flex;
              flex-direction: row;
              justify-content: start;
              align-items: center;
              gap: 42px;
              width: 100%;
              :global(.stopper__button) {
                width: auto;
              }
              :global(.stopper__link) {
                margin-top: 0px;
              }
            }
          }
        `}
      </style>
    </>
  );
}

export default DefaultErrorPage;
